export const PHASE_ORDER = [
    "input",
    "physics",
    "transfer",
    "mixing",
    "reaction",
    "equilibrium",
    "heat",
    "phase",
    "probe",
    "commit"
];
/**
 * Base class for all systems. A System is the *behavior* layer of ECS — it
 * iterates entities matching its query each fixed step and writes properties.
 *
 * Concrete systems declare `static phase` so the Scheduler dispatches them in
 * the correct order. There is no per-React-component "system" pattern here;
 * every system is registered with the world's Scheduler.
 */
export class System {
    static phase;
    init(_world) { }
    dispose() { }
}
